module.exports = __webpack_public_path__ + "img/coingecko.32f8d13c.png";